import { KInput, KButton } from "kahuna-base-react-components"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { lang } from "../../../../constants/languages"

const ReleaseDetailFilterComponents = ({
  filterDataBySearchText
}: {
  filterDataBySearchText: (searchText: string) => void
}) => {
  const [searchText, setSearchText] = useState<string>("")

  const handleChange = (newValue: string) => {
    setSearchText(newValue)
    filterDataBySearchText(newValue)
  }

  return (
    // TODO: icon missing in platform selection dropdown list
    <>
      <div className="flex flex-row justify-between items-center">
        <KInput
          width={250}
          onChange={handleChange}
          value={searchText}
          placeholder={lang.catalog.release_detail.filter_component_search_text_placeholder}
          leftIcon="/search.svg"
          background="#f5f5f5"
          hoverBackground="#fff"
        />
      </div>
    </>
  )
}

export default ReleaseDetailFilterComponents
